module.exports = __webpack_public_path__ + "static/img/Archie-Ludowyke.0071727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Archie-Ludowyke.jpg
// module id = X5OY
// module chunks = 0